import React from 'react';
import { Link, Box } from '@mui/material';

import { RICPhoneNumbers } from "./Content";
import GenericError from '../../containers/GenericError';
import { RicBeaconButton } from './BeaconRegister';



const handleRefresh = e => {
    console.log(e)
    e && window.location.reload(true);
};

export default function ServiceErrorCard() {
    const errorText = (
        <div>
            If the problem continues, call{' '}
            <Link
                href={`tel:+${RICPhoneNumbers.serviceErrorNumber}`}
                sx={{
                    color: '#086EA1',
                    borderBottom: '1px solid #086EA1',
                    textDecoration: 'none',
                    '&:hover': {
                        backgroundColor: '#fff',
                        textDecoration: 'none'
                    }
                }}
            >
                {RICPhoneNumbers.serviceErrorNumber}
            </Link>{' '}
            for technical support. Available weekdays, 7 a.m. to 10 p.m. ET, and
            weekends, 9 a.m. to 5 p.m. ET.
        </div>
    );

    const contentText = "Thanks for your patience. Please try refreshing your page or check back later."
    return (
        <Box
            className='beacon-theme-modern-outlook'
            sx={{
                width: '100%',
                minHeight: '300px'
            }}
        >
            <Box
                className='b-container'
                sx={{
                    inlineSize: 'unset !important'
                }}>
                <GenericError id='service-error' title='Sorry, something went wrong'>
                    <Box>
                        {contentText}
                    </Box>
                    <Box className='b-typography-sans-serif--caption--300 b-font-weight-light' pt='16px'>
                        {errorText}
                    </Box>
                    <Box pt='32px'>
                        <RicBeaconButton id='error-modal-refresh' onClick={e => handleRefresh(e)}>
                            Refresh Page
                        </RicBeaconButton>
                    </Box>
                </GenericError>
            </Box>
        </Box>
    );
}
